import { useEffect, useState } from 'react';
import { AdvisoryContent } from '../../common/global-types/AdvisoryContent';
import APIUtils from '../../common/api/APIUtil';
import Tips from './tips/Tips';
import advisoryContentData from '../../common/advisoryContent';
import Banner from './banners/Banner';
import Tile from './tile/Tile';
import '@ids/web-component-icon';
import '../../main.css';

type ContentProps = {
  proxyPath: string | null;
  touchpointId: string | null;
  touchpointView: string | null;
  advisoryType: string | null;
  advisoryDefault: string | null;
  overrideAdvisoryContent: string | null;
};

function TypeSelector({
  proxyPath,
  touchpointId,
  touchpointView,
  advisoryType,
  advisoryDefault,
  overrideAdvisoryContent
}: ContentProps) {
  const [viewId, setViewId] = useState<number | undefined>(undefined);
  const [advisoryContent, setAdvisoryContent] = useState<AdvisoryContent[] | undefined>(undefined);

  useEffect(() => {
    const fetchAdvise = async () => {
      const result = overrideAdvisoryContent
        ? JSON.parse(overrideAdvisoryContent) as AdvisoryContent[]
        : await APIUtils.getCall<AdvisoryContent[]>(
          proxyPath,
          '/api/listAdvisoryContent'
          + `?touchpointId=${touchpointId}&touchpointView=${touchpointView}&advisoryType=${advisoryType}`
        );

      if (result === undefined) {
        if (advisoryDefault) {
          const advisoryDefaultKeys = advisoryDefault.split(',');

          const defaultAdvisoryContents = (advisoryContentData
            .filter((ac) => advisoryDefaultKeys.includes(ac.advisorySegmentName)
              && ac.advisoryType === advisoryType
              && ac.touchpointId === touchpointId
              && ac.touchpointView === touchpointView)
            .sort(
              (a, b) => advisoryDefaultKeys.indexOf(a.advisorySegmentName)
                - advisoryDefaultKeys.indexOf(b.advisorySegmentName)
            )) as AdvisoryContent[];

          if (defaultAdvisoryContents
            && defaultAdvisoryContents.length > 0
          ) {
            setAdvisoryContent(defaultAdvisoryContents);
            setViewId(defaultAdvisoryContents[0].initialView);
          }
        }

        return;
      }

      setAdvisoryContent(result);
      setViewId(result[0].initialView);
    };

    fetchAdvise();
  }, []);

  if (advisoryContent === undefined) return null;

  if (advisoryType === 'tile') {
    return (
      <Tile
        content={advisoryContent[0]}
        dispatchElementLoadedEvent={dispatchEvent}
        proxyPath={proxyPath}
        setViewId={setViewId}
        viewId={viewId}
      />
    );
  }

  if (advisoryType === 'banner') {
    return (
      <Banner
        content={advisoryContent[0]}
        setContent={setAdvisoryContent}
        proxyPath={proxyPath}
        setViewId={setViewId}
        viewId={viewId}
      />
    );
  }

  if (advisoryType === 'tips') {
    return (
      <Tips
        content={advisoryContent}
        touchpointId={touchpointId!}
        proxyPath={proxyPath}
      />
    );
  }

  return null;
}

export default TypeSelector;
